export function toScheduledToIsoFromPickerDate(date: Date): string {
  const localEnd = new Date(
    date.getFullYear(),
    date.getMonth(),
    date.getDate(),
    23,
    59,
    59,
    999
  );
  return localEnd.toISOString();
}
